import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.scss";

export const StatsCards: React.FunctionComponent = () => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`internalToolsHomePage.gbp_places_query.stats.${key}`);

  return (
    <div className="gbp-places-query-stats-cards">
      <div className="white-border-panel gbp-places-query-stats-card">
        <div className="gbp-places-query-stats-card-title">
          {t("places_api_title")}
        </div>
        <div className="gbp-places-query-stats-card-coming-soon">
          {t("coming_soon")}
        </div>
      </div>
      <div className="white-border-panel gbp-places-query-stats-card">
        <div className="gbp-places-query-stats-card-title">
          {t("owner_check_title")}
        </div>
        <div className="gbp-places-query-stats-card-coming-soon">
          {t("coming_soon")}
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
